import React from 'react'
import { Q2_VESTIMENTA, T1_NA, T2_LEO, T4_RI } from '../_data/helper'
import View from '../../../../components/pdf/View'
import Grid, { Col } from '../../../../components/pdf/Grid'
import Separator from '../../../../components/pdf/Separator'
import LabelValue from '../replies/components/LabelValue'
import { useReplies } from '../_load/ServiceOrderLoader'
import { TAXA_METABOLICA } from '../_helpers/helpers'

export default function SumHeatBlockQuestions({ block, replies }) {
  const allReplies = useReplies()

  const allowedHeatBlockQuestions = [
    176372, 180295, 180769, 181321, 181795, 181045, 182089, 182563, 183657, 184131, 185538, 186342, 186816, 187110,
    187404, 189042
  ]

  if (!allowedHeatBlockQuestions.includes(block.questionId)) return false

  const findReplyByQuestionName = (replies, name) => {
    const clearName = string => (string ? string.replace(/\s/g, '').toLowerCase() : string)
    return replies.find(reply => clearName(reply.question.name) === clearName(name))
  }

  const tipoVestimenta = findReplyByQuestionName(allReplies, 'tipo de vestimenta')
  const comCapuz = findReplyByQuestionName(allReplies, 'com capuz?')

  const format = value => {
    if (typeof value !== 'number') return ''
    return parseFloat(value.toFixed(2))
  }

  const calcularIBUTG = (tbs, tbn, tg, replies) => {
    const temCargaSolarDireta = replies.find(b => b?.question?.name === 'CARGA SOLAR DIRETA')
    if (temCargaSolarDireta?.value) {
      return tbs?.value * 0.1 + tbn?.value * 0.7 + tg?.value * 0.2
    }
    return tbn?.value * 0.7 + tg?.value * 0.3
  }

  const calcularNivelAcao = valor => {
    const valorT1Na = T1_NA[Math.floor(valor)]
    return valorT1Na ?? 20.7
  }

  const calcularLimiteExposicao = valor => {
    const valorT2Leo = T2_LEO[Math.floor(valor)]
    return valorT2Leo ?? 24.7
  }

  const calcularRegiaoIncertezas = valor => {
    const valorT4Ri = T4_RI[Math.floor(valor)]
    return valorT4Ri ?? [23.3, 24.7]
  }

  const calcularAdicaoIbutg = vestimenta => {
    return Q2_VESTIMENTA[vestimenta] ?? 0
  }

  const calcularIbutgTotal = (comCapuz, ibutg, adicaoIbutg) => {
    if (comCapuz) {
      return adicaoIbutg + ibutg + 1
    }

    return adicaoIbutg + ibutg
  }

  const calcValues = () => {
    const resultado = replies.reduce(
      (acc, replies) => {
        const tempoExposicao = replies.find(b => b?.question?.name === 'TEMPO DE EXPOSIÇÃO (MIN)')?.value
        const tipoAtividade = replies.find(b => b?.question?.name === 'TIPO DE ATIVIDADE')?.value?.name
        const taxaMetabolica = TAXA_METABOLICA[tipoAtividade]
        const tbs = replies.find(b => b?.question?.name === 'TBS (ºC)')
        const tbn = replies.find(b => b?.question?.name === 'TBN (ºC)')
        const tg = replies.find(b => b?.question?.name === 'TG (ºC)')
        const ibutg = calcularIBUTG(tbs, tbn, tg, replies)

        return {
          taxaMetabolica: acc.taxaMetabolica + taxaMetabolica * tempoExposicao,
          ibutg: acc.ibutg + ibutg * tempoExposicao
        }
      },
      {
        taxaMetabolica: 0,
        ibutg: 0
      }
    )

    const m = resultado.taxaMetabolica / 60
    const ibutg = resultado.ibutg / 60
    const adicaoIbutg = calcularAdicaoIbutg(tipoVestimenta?.value)
    return {
      m,
      ibutg,
      adicaoIbutg,
      ibutgTotal: calcularIbutgTotal(comCapuz?.value, ibutg, adicaoIbutg),
      nivelAcao: calcularNivelAcao(m),
      limiteExposicao: calcularLimiteExposicao(m)
    }
  }

  const valores = calcValues()

  const calcularJulgamento = valores => {
    if (valores.ibutgTotal <= valores.nivelAcao) return 'ACEITÁVEL'
    if (valores.ibutgTotal <= regiaoIncertezas[0]) return 'ACIMA DO NÍVEL DE AÇÃO'
    if (valores.ibutgTotal <= regiaoIncertezas[1]) return 'REGIÃO DE INCERTEZA'
    if (valores.ibutgTotal >= valores.limiteExposicao) return 'ACIMA DO LIMITE DE EXPOSIÇÃO'

    return 0
  }

  const regiaoIncertezas = calcularRegiaoIncertezas(valores.m)

  return (
    <View align="end">
      <Grid align="end" direction={'column'}>
        <Col width={'100%'} flex={1}>
          <LabelValue label={'RESULTADOS DA MEDIÇÃO'} value={''} />
          <LabelValue label={'M(média ponderada)'} value={`${format(valores.m)} W`} />
          <LabelValue label={'IBUTG(médio ponderado)'} value={`${format(valores.ibutg)} °C`} />
          <LabelValue label={'Adição ao IBUTG Médio Ponderado'} value={`${format(valores.adicaoIbutg)} °C`} />
          <LabelValue label={'IBUTG(médio ponderado) Total'} value={`${format(valores.ibutgTotal)} °C`} />
          <LabelValue
            label={
              'Nível de ação para trabalhadores aclimatizados e limite de exposição ocupacional ao calor para trabalhadores não aclimatizados'
            }
            value={`${format(valores.nivelAcao)} °C`}
          />
          <LabelValue
            label={'Limite de exposição ocupacional ao calor para trabalhadores aclimatizados'}
            value={`${format(valores.limiteExposicao)} °C`}
          />
          <LabelValue
            label={'Região de incertezas para trabalhadores aclimatizados'}
            value={`${regiaoIncertezas[0]} a ${regiaoIncertezas[1]} °C`}
          />
          <LabelValue label={'Critério de julgamento e tomada de decisão'} value={calcularJulgamento(valores)} />
        </Col>
      </Grid>
      <Separator weight={4} />
    </View>
  )
}
